module.exports = __webpack_public_path__ + "img/rocketleague_prizing.39d4517e.jpg";